import { useCallback } from 'react';
import { useIntercom } from 'react-use-intercom';
import { useAuthUser } from '../api';

export const useIntercomWithDomainCheck = () => {
	const intercom = useIntercom();
	const { user } = useAuthUser();

	const bootWithCheck = useCallback(async () => {
		if (user?.email?.includes('test.secoda.co')) {
			return;
		}
		intercom.boot({ alignment: 'left', horizontalPadding: 60 });
	}, [intercom, user?.email]);

	const showWithCheck = useCallback(() => {
		if (user?.email?.includes('test.secoda.co')) {
			return;
		}
		intercom.show();
	}, [intercom, user?.email]);

	return {
		...intercom,
		boot: bootWithCheck,
		show: showWithCheck,
	};
};
